import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://greenbook.co.il/",
});

export default axiosInstance;
